import {createColumnHelper} from '@tanstack/react-table';
import {DeleteButtonWithConfirmation, EditButton} from 'components/refinedev/action_buttons';
import {defaultQueryOptions} from 'pages/_utils';
import StateBoundary from '@/components/basic/StateBoundary';
import {DataTableColumnHeader} from '@/components/data-table/data-table-column-header';
import useRefineTanstackDataTable from '@/hooks/refinedev/useRefineTanstackDataTable';
import {DataTable} from '@/components/data-table/data-table';
import DefaultDataTableToolbar from '@/components/refinedev/data-table/DefaultDataTableToolbar';
import {SelectColumn} from '@/components/data-table/columns';
import {TrashIcon} from 'lucide-react';
import {useBulkDelete} from '@/components/refinedev/data-table/use-bulk-delete';
import {TaskEditDialogButton} from '../tasks/components/task-edit-dialog-button';
import DataTableFilters from '@/components/data-table/data-table-filters';
import StaffFilters from './components/staff-filter';

const thisResource = 'staffs';

const columnHelper = createColumnHelper<any>();

export const columns = [
  SelectColumn,
  columnHelper.accessor('id', {
    id: 'id',
    meta: {label: 'ID'},
    header: ({column}) => <DataTableColumnHeader column={column} />,
    cell: info => info.getValue(),
  }),
  columnHelper.accessor('name', {
    id: 'name',
    meta: {label: 'Họ và tên'},
    header: ({column}) => <DataTableColumnHeader column={column} />,
    cell: info => info.renderValue(),
    filterFn: 'includesString',
  }),
  // columnHelper.accessor('role', {
  //   id: 'role',
  //   meta: {label: 'Vai trò'},
  //   header: ({column}) => <DataTableColumnHeader column={column} />,
  //   cell: info => info.renderValue(),
  // }),
  columnHelper.accessor('department_name', {
    id: 'department_name',
    meta: {label: 'Phòng ban'},
    header: ({column}) => <DataTableColumnHeader column={column} />,
    cell: info => info.renderValue(),    
    // enableSorting: false,    
  }),
  columnHelper.accessor('job_title', {
    id: 'job_title', 
    meta: {label: 'Công việc'},
    header: ({column}) => <DataTableColumnHeader column={column} />,
    cell: info => info.renderValue(),
  }),
  columnHelper.display({
    id: 'actions',
    meta: {label: 'Hành động'},
    header: ({column}) => <DataTableColumnHeader column={column} />,
    cell: info => (
      <div className="flex flex-row">
        <EditButton id={String(info.row.getValue('id'))} resource={thisResource} />
        <DeleteButtonWithConfirmation id={String(info.row.original.id)} resource={thisResource} />
      </div>
    ),
  }),
];

const StaffList = () => {
  const {refineTable, tanstackTable} = useRefineTanstackDataTable(
    {
      resource: thisResource,
      sorters: {initial: [{field: 'id', order: 'asc'}]},
      queryOptions: defaultQueryOptions,
      syncWithLocation: true,
      meta: {
        // with: ['department', 'job'],
      },
    },
    {columns},
  );

  const bulkDelete = useBulkDelete(thisResource, tanstackTable);

  return (
    <StateBoundary
      isLoading={refineTable.tableQuery.isLoading}
      error={refineTable.tableQuery.error}>
      <div className="p-2">
        <DataTable
          table={tanstackTable}
          toolbar={
            <DefaultDataTableToolbar
              resource={thisResource}
              table={tanstackTable}
              bulkActions={[bulkDelete]}
              filters={<StaffFilters table={refineTable} />}
            />
          }
        />
      </div>
    </StateBoundary>
  );
};

StaffList.table_columns = columns;

export default StaffList;
